module.exports = __webpack_public_path__ + "assets/2aaa2910715eac3725fdb3fe043ea62b.png";